import { render, staticRenderFns } from "./ConfrimMint.vue?vue&type=template&id=818dc7b2&scoped=true"
import script from "./ConfrimMint.vue?vue&type=script&lang=js"
export * from "./ConfrimMint.vue?vue&type=script&lang=js"
import style0 from "./ConfrimMint.vue?vue&type=style&index=0&id=818dc7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818dc7b2",
  null
  
)

export default component.exports